/* content file: replace all html between <> </> with actual content */

export const BuchDigitalisierung = () => { 
  return (
  <>
    <p>
      Im Jahr 2025 erschien im Campus Verlag das Buch „Digitalisierung – So gelingt die Transformation wirklich“, das von Prof. clin. assoc. Dr. med. Peter Tinnemann und Stefanie Kaulich herausgegeben wurde. Es beleuchtet zentrale Themen wie IT-Sicherheit, Interoperabilität, nutzerorientierte Softwareentwicklung und organisatorische Transformation. Darüber hinaus gibt es Einblicke in die Entstehung von GA-Lotse und setzt sich fundiert mit den Herausforderungen und Chancen der Digitalisierung im Öffentlichen Gesundheitsdienst (ÖGD) auseinander.
    </p>
    <p>
      <strong>Erhältlich ist das Buch überall im Buchhandel als Hardcover oder E-Book.</strong>
    </p>
    <div>
          <ul className="list-none list-inside space-y-2 mt-8 pl-4">
      <li>
        <a 
        target="_blank" 
        rel="noreferrer" 
        className="text-primary-plain-Color hover:underline mx-1" 
        href='https://books.google.de/books?id=XNgrEQAAQBAJ&printsec=frontcover'
      >
        Leseprobe bei Google Books
      </a>
      </li>
      <li>
        <a 
        target="_blank" 
        rel="noreferrer" 
        className="text-primary-plain-Color hover:underline mx-1" 
        href='https://www.campus.de/buecher-campus-verlag/business/management-unternehmensfuehrung/digitalisierung-18496.html'
      >
        Buchinfo und Leseprobe beim Campus-Verlag
      </a>
      </li>
    </ul>
    </div>
  </>    
  )
}